import React, { useState, useEffect, useRef } from 'react';
import './Chatbot.css';
import { sendChatMessage } from '../../services/chatbot.service';
import { getRoleInfo } from '../../services/user.service';
import * as CryptoJS from "crypto-js";
const Chatbot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [history, setHistory] = useState([
        { role: 'bot', text: 'Hello! I am your AI assistant. How can I help you today?' }
    ]);
    const [isTyping, setIsTyping] = useState(false);
    const [chatbotEnabled, setChatbotEnabled] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const role_id = sessionStorage.getItem('LoggedInRoleId');

                if (!role_id) {
                    setCheckingStatus(false);
                    return;
                }

                let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': { 'role_id': role_id },
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                let oData1 = { 'token': EncryptData };

                getRoleInfo(oData1).then(function (res) {
                    if (res?.data?.data?.length) {
                        var aInfo = res.data.data[0];
                        setChatbotEnabled(aInfo.is_chatbot_enabled === '1' || aInfo.is_chatbot_enabled === 1);
                    }
                    setCheckingStatus(false);
                }).catch(e => setCheckingStatus(false));

            } catch (e) {
                setCheckingStatus(false);
            }
        };
        checkStatus();
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [history]);

    if (checkingStatus || !chatbotEnabled) {
        return null;
    }

    const handleSend = async (e) => {
        if (e) e.preventDefault();
        if (!message.trim()) return;

        const userMessage = message.trim();
        setMessage('');
        setHistory(prev => [...prev, { role: 'user', text: userMessage }]);
        setIsTyping(true);

        try {
            // Get user info from localStorage if available (for company_id)
            const user = JSON.parse(localStorage.getItem('user'));
            const company_id = user?.company_id;
            let obj = {
                message: userMessage,
                history: history.slice(-5), // Send last 5 messages for context
                user: company_id || null
            }
            let EncryptObj = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = { 'token': EncryptObj }
            sendChatMessage(oData1).then(function (res) {
                setHistory(prev => [...prev, { role: 'bot', text: res.data.message }]);
            })
        } catch (error) {
            console.error("Chat error:", error);
            setHistory(prev => [...prev, { role: 'bot', text: "I'm sorry, I'm having trouble connecting right now. Please try again later." }]);
        } finally {
            setIsTyping(false);
        }
    };

    return (
        <div className="chatbot-container">
            {!isOpen && (
                <button className="chat-toggle-btn" onClick={() => setIsOpen(true)}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 9C21 10.6569 19.6569 12 18 12C19.6569 12 21 13.3431 21 15C21 13.3431 22.3431 12 24 12C22.3431 12 21 10.6569 21 9Z" fill="white" />
                        <path d="M12 2C12 7.52285 7.52285 12 2 12C7.52285 12 12 16.4772 12 22C12 16.4772 16.4772 12 22 12C16.4772 12 12 7.52285 12 2Z" fill="white" />
                        <path d="M18 1C18 3.20914 16.2091 5 14 5C16.2091 5 18 6.79086 18 9C18 6.79086 19.7909 5 22 5C19.7909 5 18 3.20914 18 1Z" fill="white" />
                    </svg>
                </button>
            )}

            {isOpen && (
                <div className="chat-window">
                    <div className="chat-header">
                        <h3>CapexBot-AI Assistant</h3>
                        <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
                    </div>

                    <div className="chat-messages">
                        {history.map((msg, index) => (
                            <div key={index} className={`message ${msg.role}`}>
                                {msg.text}
                            </div>
                        ))}
                        {isTyping && (
                            <div className="message bot">
                                <div className="typing">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                            </div>
                        )}
                        <div ref={messagesEndRef} />
                    </div>

                    <form className="chat-input-area" onSubmit={handleSend}>
                        <input
                            type="text"
                            placeholder="Ask me anything..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            disabled={isTyping}
                        />
                        <button type="submit" className="send-btn" disabled={isTyping || !message.trim()}>
                            <i className="fa fa-paper-plane"></i>
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default Chatbot;
